import { AbstractControl, AsyncValidatorFn } from "@angular/forms";
import { SignUpCreateAccountService } from "../services/create-account.service";

export function checkDomainValidator(
  createAccountService: SignUpCreateAccountService
): AsyncValidatorFn {
  return (control: AbstractControl): Promise<{ [key: string]: string } | null> => {
    return createAccountService.checkDomain(control.value).then(valid => {
      // eslint-disable-next-line no-null/no-null
      return !valid ? { domainUnavailable: control.value } : null;
    });
  };
}
